// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pb-0";